<template>
  <el-upload
    drag
    action=""
    :limit="limit"
    :size="size"
    :http-request="uploadAttachment"
    ref="upload"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    <div class="el-upload__tip" slot="tip">
      <div v-if="showDefaultTip">
        仅支持xls/xlsx格式的文件，文件大小不能超过{{ size }}M
      </div>
      <slot name="customTip"></slot>
    </div>
  </el-upload>
</template>

<script>
import FileHandler from "@/utils/file";

export default {
  props: {
    limit: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 2
    },
    showDefaultTip: {
      type: Boolean,
      default: true
    },
    /*上传文件格式,仅在type=attachment时有效,支持的格式为word/excel/ppt/pdf/jpg/png/txt中的一种或多种,默认都支持 */
    accepts: {
      type: Array,
      default: () => {
        return ["excel", "txt"];
      },
    },
  },
  model: {
    prop: "file",
    event: "returnBack"
  },
  methods: {
    async uploadAttachment(e) {
      let file = e.file;
      // 文件上传之前校验文件是否符合格式要求,符合继续上传，不符合终止上传
      if (file.size > this.size * 1024 * 1024) {
        this.$refs.upload.uploadFiles.pop();
        this.$message.warning("附件大小不能超过2M,请重新选择文件");
        return;
      }
      // 我改的时候是默认这两个类型 ["excel", "txt"]， 我变更成传入 accepts
      let isExcel = await FileHandler.isAttachment(file, this.accepts);
      if (!isExcel) {
        this.$refs.upload.uploadFiles.pop();
        this.$message.warning("附件格式不符合要求,请重新选择文件");
        return;
      }
      this.$emit("returnBack", file);
    },

    handleRemove(file, fileList) {
      this.$emit("returnBack", null);
    }
  }
};
</script>

<style lang="scss" scoped></style>
